import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react-pro'
import './ConfirmModal.scss'
import { userSettingGet, userSettingPut } from '../../../../../redux/user/userThunk'

export default function AsteriskConfirm({ handleClose, onConfirm }) {
  const dispatch = useDispatch()
  const [isChecked, setIsChecked] = useState(false)
  const settings = useSelector((state) => state.user?.settings)

  return (
    <CModal
      className="confirm-modal"
      visible={true}
      onClose={handleClose}
      fullscreen="lg"
      alignment={'center'}
    >
      <CModalHeader className="d-flex">Are you sure?</CModalHeader>
      <CModalBody>
        <div style={{ textAlign: 'center' }}>
          There are asterisks ( *** ) in your note. Use jump codes (ctrl+h) to identify the
          asterisks.
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '16px',
            marginTop: '24px',
          }}
        >
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              setIsChecked(e?.currentTarget?.checked)
            }}
          />
          <div>Don&apos;t show again for 30 days</div>
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={handleClose}>
          Cancel
        </CButton>
        <CButton
          color="primary"
          onClick={async () => {
            if (isChecked) {
              let newUserSettings = {
                ...settings,
                asteriskWarningExpiration: new Date().toISOString(),
              }
              if (Object.keys(newUserSettings)?.length > 1) {
                await dispatch(userSettingPut(newUserSettings))
                dispatch(userSettingGet())
              }
            }
            onConfirm()
          }}
        >
          Sign anyway
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
